module.exports = __webpack_public_path__ + "static/media/mark_lven_palejaro.07093e8b.JPG";